import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { PiWineDuotone } from "react-icons/pi";
import { authService } from "./services/authService";

const Header = ({ onSelectMenu, isLoggedIn, setIsLoggedIn, username, setUsername }) => {
  const navigate = useNavigate();

  const handleNavigation = (menu, path) => {
    onSelectMenu(menu);
    navigate(path);
  };
  
  const handleLogout = async () => { 
    await authService.logout();
    setIsLoggedIn(false);
    setUsername("");
    navigate("/login");
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Navbar.Brand
        style={{ cursor: 'pointer' }}
        className="mx-3"
        onClick={() => handleNavigation('regal', '/')}
      >
        <PiWineDuotone color="red" size={24}/> AnPlöger Weinregal
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          <Nav.Link
            onClick={() => handleNavigation('regal', '/')}
          >
            Regal
          </Nav.Link>
          <Nav.Link
            onClick={() => handleNavigation('weine', '/weine')}
          >
            Weine
          </Nav.Link>
          {isLoggedIn && (
           <>          
            <Nav.Link
              onClick={() => handleNavigation('einkauf', '/einkauf')}
            >
              Einkauf
            </Nav.Link>
            <Nav.Link
              onClick={() => handleNavigation('probe', '/probe')}
            >
              Probe
            </Nav.Link>
            <Nav.Link
              onClick={() => handleNavigation('statistik', '/statistik')}
            >
              Statistik
            </Nav.Link>
            <Nav.Link
              onClick={() => handleNavigation('sommeliere', '/sommeliere')}
            >
              Sommelière
            </Nav.Link>
           </>
          )}
        </Nav>
        {!isLoggedIn ? (
          <Nav>
            <Nav.Link onClick={() => navigate("/login")}>Login</Nav.Link>
          </Nav>
        ) : (
          <Nav>
            <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
          </Nav>
        )}
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;